export default __webpack_public_path__ + "static/media/avatar.84607289.jpg";